const LEGAL_SITE_URL = 'https://www.openlettermarketing.com'

const escapeAttribute = (value = '') =>
    String(value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')

const stripTags = (html = '') =>
    String(html)
        .replace(/<[^>]*>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()

const decodeCommonEntities = (value = '') =>
    String(value)
        .replace(/&#038;|&amp;/g, '&')
        .replace(/&#039;|&apos;/g, "'")
        .replace(/&#8211;|&ndash;/g, '-')
        .replace(/&#8212;|&mdash;/g, '-')
        .replace(/&#8220;|&#8221;|&quot;/g, '"')
        .replace(/&#8230;|&hellip;/g, '...')
        .replace(/&nbsp;/g, ' ')
        .trim()

const buildRobotsContent = (robots) => {
    if (!robots || typeof robots !== 'object') return null

    return Object.entries(robots)
        .map(([key, value]) => {
            if (typeof value === 'boolean') {
                if (value) return key
                if (key === 'index') return 'noindex'
                if (key === 'follow') return 'nofollow'
                return null
            }

            return value || null
        })
        .filter(Boolean)
        .join(', ')
}

export const legalPageLinks = [
    {
        href: '/terms',
        label: 'Terms',
        title: 'Terms of Service',
    },
    {
        href: '/terms/end-user-agreement',
        label: 'End User Agreement',
        title: 'End User Agreement',
    },
    {
        href: '/terms/reseller-agreement',
        label: 'Reseller Agreement',
        title: 'Reseller Agreement',
    },
    {
        href: '/terms/service-level-agreement',
        label: 'Service Level Agreement',
        title: 'Service Level Agreement',
    },
]

export const sanitizeLegalContent = (html = '') =>
    String(html)
        .replace(/<meta[^>]*>/gi, '')
        .replace(/<title[^>]*>[\s\S]*?<\/title>/i, '')
        .replace(/<h1\b[^>]*>[\s\S]*?<\/h1>/i, '')
        .trim()

export const getLegalPageTitle = (data, fallbackTitle) => {
    const renderedTitle = decodeCommonEntities(
        stripTags(data?.title?.rendered || ''),
    )

    return renderedTitle || fallbackTitle
}

export const buildLegalMeta = ({
    data,
    title,
    path,
    description: descriptionOverride,
}) => {
    const yoast = data?.yoast_head_json || {}
    const siteName = yoast.og_site_name || 'Open Letter Marketing'
    const metaTitle = `${title} - ${siteName}`
    const description =
        descriptionOverride ||
        yoast.description ||
        yoast.og_description ||
        stripTags(data?.excerpt?.rendered || data?.content?.rendered || '')
    const canonical = `${LEGAL_SITE_URL}${path}`
    const robotsContent = buildRobotsContent(yoast.robots)
    const ogType = yoast.og_type || 'article'
    const ogLocale = yoast.og_locale || 'en_US'
    const twitterCard = yoast.twitter_card || 'summary_large_image'
    const modifiedTime = yoast.article_modified_time || data?.modified_gmt

    const meta = [
        description
            ? `<meta name="description" content="${escapeAttribute(
                  description,
              )}" />`
            : '',
        robotsContent
            ? `<meta name="robots" content="${escapeAttribute(
                  robotsContent,
              )}" />`
            : '',
        `<link rel="canonical" href="${escapeAttribute(canonical)}" />`,
        `<meta property="og:locale" content="${escapeAttribute(ogLocale)}" />`,
        `<meta property="og:type" content="${escapeAttribute(ogType)}" />`,
        `<meta property="og:title" content="${escapeAttribute(metaTitle)}" />`,
        description
            ? `<meta property="og:description" content="${escapeAttribute(
                  description,
              )}" />`
            : '',
        `<meta property="og:url" content="${escapeAttribute(canonical)}" />`,
        `<meta property="og:site_name" content="${escapeAttribute(
            siteName,
        )}" />`,
        modifiedTime
            ? `<meta property="article:modified_time" content="${escapeAttribute(
                  modifiedTime,
              )}" />`
            : '',
        `<meta name="twitter:card" content="${escapeAttribute(
            twitterCard,
        )}" />`,
        `<meta name="twitter:title" content="${escapeAttribute(metaTitle)}" />`,
        description
            ? `<meta name="twitter:description" content="${escapeAttribute(
                  description,
              )}" />`
            : '',
    ]
        .filter(Boolean)
        .join('\n')

    return {
        meta,
        metaTitle,
    }
}
